// extracted by mini-css-extract-plugin
export default {"selectParent":"select_selectParent__UoFe6","select":"select_select__yMcmC","svgFunnel":"select_svgFunnel__quCb8"};